import React from 'react';
import { Link } from 'react-router-dom';
import colors from '../colors';

function Terms() {
    return (
        <div style={styles.pageWrapper}>
            <div style={styles.topBar}>
                <Link to="/" style={styles.backButton}>← Back</Link>
            </div>
            <div style={styles.container}>
                <h1>Terms of Service</h1>
                <p>Welcome to Wisemoji ("we," "us," or "our"). By accessing or using wisemoji.com (the "Website"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to all of these Terms, please do not use the Website.</p>

                <h3>1. Acceptance of Terms</h3>
                <p>By using our Website, you confirm that you have read, understood, and agree to these Terms and our Privacy Policy.</p>

                <h3>2. No Investment Advice</h3>
                <p><strong>Informational Purposes Only:</strong> The content provided on this Website is for informational purposes only and does not constitute financial, investment, or other professional advice.</p>
                <p><strong>No Recommendations:</strong> We do not recommend that any cryptocurrency should be bought, sold, or held by you.</p>

                <h3>3. Risk Disclosure</h3>
                <p><strong>Volatility Risk:</strong> Investing in cryptocurrencies involves significant risk, including the potential loss of all invested funds.</p>
                <p><strong>User Responsibility:</strong> You acknowledge that you are solely responsible for any investment decisions you make.</p>

                <h3>4. Limitation of Liability</h3>
                <p><strong>No Liability for Losses:</strong> Under no circumstances shall Wisemoji be liable for any direct, indirect, incidental, special, consequential, or exemplary damages resulting from your use of the Website or investment in Wisemoji tokens.</p>
                <p><strong>"As Is" Basis:</strong> The Website is provided on an "as is" and "as available" basis without warranties of any kind.</p>

                <h3>5. Intellectual Property Rights</h3>
                <p><strong>Ownership:</strong> All content on the Website, including text, graphics, logos, and images, is the property of Wisemoji or its content suppliers and is protected by intellectual property laws.</p>
                <p><strong>License:</strong> We grant you a limited, non-exclusive, non-transferable license to access and use the Website for personal, non-commercial purposes.</p>

                <h3>6. User Conduct</h3>
                <p>You agree not to use the Website for any unlawful purpose or in any way that could harm the Website or impair anyone else's use of it.</p>

                <h3>7. Termination</h3>
                <p>We reserve the right to suspend or terminate your access to the Website at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users.</p>

                <h3>8. Changes to the Terms</h3>
                <p>We reserve the right to modify or replace these Terms at any time. We will provide notice of any significant changes by posting the new Terms on this page.</p>
            </div>
        </div>
    );
}

const styles = {
    pageWrapper: {
        backgroundColor: colors.primaryDark,
        minHeight: '100vh',
        padding: '20px',
    },
    topBar: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '20px',
    },
    backButton: {
        backgroundColor: colors.primaryDark,
        color: colors.textLight,
        padding: '10px 20px',
        borderRadius: '5px',
        fontSize: '1rem',
        textDecoration: 'none',
        cursor: 'pointer',
    },
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'Press Start 2P, cursive',
        lineHeight: '1.6',
        color: colors.textLight,
    },
};

export default Terms;